import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'

import { LoginService } from "src/app/components/Shared/Service/login_service";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import beautify from 'xml-beautifier';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: Date;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-guestvisitrevenuesync',
  templateUrl: './guestvisitrevenuesync.component.html',
  styleUrls: ['./guestvisitrevenuesync.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class GuestvisitrevenuesyncComponent implements OnInit {

  today = new Date();
  today1 = new Date();
  Val: string;
  hotellistproperty: any = []
  lstBooking: any = [];
  
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  displayedColumns = ['Status','Hotel','accdat', 'gstcod','createdatetime','fxresdt','bwresdt','CRSRequest','BWRequest','BWResponse'];
  apiresult: any;
  Pmscodevalue: any;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  selectedDateStore: any;
  selectedTOODateStore: any;
  filterProperty: any;
  blinkOfflineHotel: boolean;
  currentDateStore: any;
  storeHeartBeatValue: any;
  XMLName: any;
  defaultData: any;
  status: void;
  requestPayload: any;
  totalcount: any = 0;
  pageSize = 50;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, 
    private datePipe: DatePipe) { 
      
    }
    
  display: Boolean = false;
  public User: string;
  selectedDate: any = new Date(this.today.setDate(this.today.getDate()));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate()));
  isProgressing: Boolean = false;
  lstGetCMHotelsProperty: any = [];
  storePmsCode: string
  Userid: any = [];
  selectedProperty: any;
  isIDSUser: boolean;
  search: string;
  statusResult: string;
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  checkTodayDate:any
  CurrentDate = new Date();
  searchBarFilter: boolean = false;

  hideSearchFilter(){
    this.Val = '';
    this.searchBarFilter = false
  }
  ngOnInit() {
    console.log('Page Size =',this.pageSize)
    this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    this.isProgressing = true;
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.errorMsgSubscription = true
    this.statusResult = "not sent"
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  GetParseonlyDateTimeHeartbeat(d:any) {
    var dt1 = new Date(d);
    var dt2 = new Date();
    // console.log('dt1 = ',dt1)
    // console.log('dt2 = ',dt2)
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    // console.log('Math ABS = ',Math.abs(Math.round(diff)));
    if(Math.abs(Math.round(diff)) > 60){
      return false
    }else{
      return true
    }
      }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getGuestVisitRevenueSyncPropList()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          this.apiresult.unshift({
            "propertyCode": "All",
            "propertyName": "All Property"
          });

          this.dropdownDeptData = this.apiresult
          // if (this.SourceBy == 'Report') {
          this.selectedDeptItems = this.getDimensionsByFilter("All");
          console.log('this.StoreValuetest', this.selectedDeptItems[0].propertyCode);
          this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
          console.log('this.Pmscodevalue =', this.Pmscodevalue)
          // }
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });
  }


  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
    this.Val = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.totalcount = 0
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }
  getDimensionsByFilter(propertyCode: any) {
    console.log('dropdownDeptData =', this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }


   GetLoadMethodIDSUser() {
    this.searchBarFilter = true
    this.isProgressing = true;
    this.selectedDateStore = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODateStore = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    console.log('selectedProperty Result = ', this.Pmscodevalue)
    console.log('selectedDate Result = ', this.selectedDateStore)
    console.log('selectedTOODate Result = ', this.selectedTOODateStore)
    console.log('Status Result = ', this.statusResult)
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    } else {
      this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "FRMDATE": this.selectedDateStore,
        "TOODATE": this.selectedTOODateStore,
        "STATUS": this.statusResult,
      }
      this.apiCallIdsService.readGuestVisitRevenueSyncAPI(this.requestPayload)
        .subscribe((data) => {
          console.log('response =', data);
          if (data.length < 1) {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          else {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.totalcount = data.length
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
    }

  }

  Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { propertyCode: { toString: () => string; }; propertyName: { toString: () => string; }; gstcod: { toString: () => string; } }) => {
      return res.propertyCode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.propertyName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.gstcod.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
      this.totalcount = 0
      this.GetLoadMethodIDSUser()
    }
  }

  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.GetLoadMethodIDSUser();
  }


  showXml(token: any, xmltype: any) {
      this.status = this.LoadXML(token, xmltype);
  }
  LoadXML(token: any,xmltype: any) {
    this.isProgressing = true;
    console.log('token',token);
    console.log('xmltype',xmltype);
    this.apiCallIdsService.GuestVisitRevenueSyncJSON(token, xmltype)
      .subscribe(data => {
        if (data.length < 1) {
          this.toastr.error('No data to load');
        }else{
          const xml = beautify(data[0].jsonData);
          console.log(xml);
          if(xmltype == 'CRSRequest'){
            this.XMLName = "CRS Request"
          }
          else if(xmltype == 'BWRequest'){
            this.XMLName = "BW Request"
          }
          else if(xmltype == 'BWResponse'){
            this.XMLName = "BW Response"
          }
          
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
}